import React, { Component } from "react";
import { isValid, FILE_SIZE_LABEL } from "../../../form-inputs/imageUploader/lib/fileHelper";

export class UpcImageUpload extends Component {
    constructor() {
        super();

        this.state = {
            currentFileName: "",
        };
    }

    launchFileSelect = () => {
        document.getElementById("imageToAdd").click();
    };

    updateCurrentFile = (event) => {
        let file = event.target.files[0];

        if (file) {
            if (!isValid(file)) {
                file = null;
                event.target.value = null;
                this.setState({
                    currentFileName: "",
                });
            } else {
                const fullPath = file.name;
                this.setState({
                    currentFileName: fullPath.replace(/^.*[\\/]/, ""),
                });
            }

            this.props.updateState("damageImage", file);
        }
    };

    render() {
        const fileName = this.state.currentFileName ? <small>{this.state.currentFileName}</small> : null;
        const label = this.props.label ? (
            <div>
                <label>{this.props.label}:</label>
            </div>
        ) : null;

        return (
            <div className="form-field">
                {label}
                <p>
                    <small>File size must be less than {FILE_SIZE_LABEL}</small>
                    <br />
                    <small>Allowed files: jpg, png</small>
                </p>
                <div className="file-upload">
                    <button className="button -small">Add Image</button> {fileName}
                    <input type="file" id="imageToAdd" ref={(input) => (this.imageToAdd = input)} onChange={this.updateCurrentFile} accept=".jpg,.jpeg,.png" />
                </div>
            </div>
        );
    }
}
